import { api } from "./configs/axiosConfigs";

export const MembershipPaymentsAPI = {
  getPayments: async (memberId) => {
    const response = await api.get(
      `/members/${memberId}/membership_payments`,
    );
    return response?.data;
  },

  addPayment: async (memberId, form) => {
    const response = await api.post(
      `/members/${memberId}/membership_payments`,
      form,
    );
    return response?.data;
  },

  updatePayment: async (id, form) => {
    const response = await api.patch(`/membership_payments/${id}`, form);
    return response?.data;
  },

  deletePayment: async (id) => {
    const response = await api.delete(`/membership_payments/${id}`);
    return response?.data;
  },
};
